import axios from 'axios'
import { BASE_URL } from '../../utils/constants/url'
import generalHeader from '../../utils/constants/generalHeader'

const resetPassword = async (data) => {
  const url = `${BASE_URL}/auth/reset-password`

  return axios.post(url, data, {
    headers: generalHeader(),
  })
}

export default resetPassword
